import React  from 'react';
import { useTranslation } from 'react-i18next';
import { 
    Section,
    Title,
    TitleSec,
    Name,
    Department,
    SendEmailButton,
    LinkedinButton,
    UserBox,
    UserBoxContainer,
    ImageBox,
    ButtonFlexbox,
    WhiteCircle,
    BoxImage,
    YellowCircle,
    StarImg,
} from './style'
import { Box } from 'reflexbox'
import Profile1 from '../../image/profile1.png'
import Profile2 from '../../image/profile2.png'
import Profile3 from '../../image/profile3.png'
import Email from '../../image/email.png'
import Linkedin from '../../image/linkedin.png'
import Star from '../../image/Star.png'


const data = [
    {
        name: "Agust Doloksaribu",
        image: Profile1,
        department: "Managing Partner of Sequoia Advocates",
        linkedin: "https://linkedin.com/in/agust-doloksaribu-ba817849",
        email: "doloksaribu@sequoiaadvocates.com"
    },
    {
        name: "Hisar" +
             "\nJohannes",
            image: Profile2,
        department: "Partner of Sequoia Advocates",
        linkedin: "https://www.linkedin.com/in/hisar-johannes-13526121b/",
        email: "hisar.johannes@sequoiaadvocates.com"
    },
    {
        name: "Randolph Yosua Siagian",
        image: Profile3,
        department: "Partner of Sequoia Advocates",
        linkedin: "https://linkedin.com/in/randolph-yosua-siagian-213144ba",
        email: "randolph.yosua@sequoiaadvocates.com"
    }
]

export const IntroductingComponents = () => {
    const { t } = useTranslation('common');
    return (
        <Section>
            <Title>
                {t('introducing.title') || 'Introducing Our Legal Experts.'}{' '}
                <TitleSec>
                    {t('introducing.subtitle') || 'Meet our leading Legal Professionals for Your Legal Needs.'}
                </TitleSec>
            </Title>
            <UserBoxContainer>
                {data.map((user) => (
                    <UserBox>
                        <BoxImage>
                            {/* <WhiteCircle>
                                <YellowCircle>
                                    <StarImg 
                                        src={Star} 
                                        alt="star" 
                                    />
                                </YellowCircle>
                            </WhiteCircle> */}
                            <ImageBox 
                                src={user.image} 
                                alt="" 
                            />
                        </BoxImage>
                        <Name>{user.name}</Name>
                        <Department>{user.department}</Department>
                        <ButtonFlexbox>
                            <SendEmailButton onClick={() => window.open(`mailto:${user.email}`, '_blank')}>
                                <img 
                                    src={Email} 
                                    alt="" 
                                    width="28px" 
                                    height="auto"
                                />
                                <Box 
                                    marginLeft='16px'
                                    fontFamily='sans-serif'
                                    fontWeight='bold'
                                >
                                    {t('introducing.sendEmail') || 'Send email'}
                                </Box>
                            </SendEmailButton>
                            {/* <a href="https://linkedin.com/in/agust-doloksaribu-ba817849" target="_blank" width='auto'> */}
                                <LinkedinButton onClick={() => window.open(user.linkedin, '_blank')}>
                                    <div>
                                        <img 
                                            src={Linkedin} 
                                            alt=""
                                            width="26px"
                                            height="26px"
                                        />
                                    </div>
                                    <Box 
                                        marginLeft='16px'
                                        fontFamily='sans-serif'
                                        fontWeight='bold'
                                    >
                                        {t('introducing.connect') || "Let's connect"}
                                    </Box>
                                    </LinkedinButton>        
                                {/* </a> */}
                        </ButtonFlexbox>
                    </UserBox>
                ))}
            </UserBoxContainer>
        </Section>
    )
}